<div class="container-fluid">
  <h1 class="responsive-heading">DASHBOARD SEGUIMIENTO CUBICA+</h1>
  <div class="card mb-4">
    <div class="mt-2 alert alert-info">
      <strong>Filtros de búsqueda</strong>
    </div>
    <div class="card-body py-2">
      <div class="row">
        <!-- Código Bodega -->
        <div class="col-lg-5 col-md-6 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="w-100 small-form-field">
            <mat-label>Código Bodega</mat-label>
            <input type="text" matInput [formControl]="filtroBodega" [matAutocomplete]="auto"
              placeholder="Buscar bodega">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayBodega"
              (optionSelected)="onBodegaSelected($event)">
              <mat-option *ngFor="let bodega of bodegasFiltradas | async" [value]="bodega">
                {{bodega.cod}} - {{bodega.nombre}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Fecha -->
        <div class="col-lg-5 col-md-6 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="w-100 small-form-field">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="fechaControl" placeholder="Seleccione fecha">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        
        <!-- Botón de búsqueda -->
        <div class="col-lg-2 col-md-12 col-sm-12 mb-2 d-flex align-items-center">
          <button class="btn btn-info btn-sm w-100" (click)="BuscarCapacidadesTransporte()">
            <mat-icon class="small-icon">search</mat-icon>
            <span class="d-none d-md-inline-block ms-1"></span>
          </button>
        </div>
      </div>
      
      <!-- Toggle para vista mensual y botón de descarga -->
      <div class="row mt-2">
        <div class="col-12 d-flex align-items-center justify-content-center gap-3">
          <mat-slide-toggle 
            [checked]="vistaMensual" 
            [disabled]="!cod_bodega"
            (change)="toggleVistaMensual($event)"
            class="monthly-toggle">
            <span class="toggle-label">Vista 30 dias</span>
          </mat-slide-toggle>
          
          <button class="btn btn-info btn-sm"
                  [disabled]="!cod_bodega"
                  (click)="vistaMensual ? descargarReporteMensual() : obtenerDetalleFechaPickind()"
                  [title]="vistaMensual ? 'Descargar reporte general vista 30 días' : 'Descargar reporte actual'">
            <mat-icon class="small-icon">file_download</mat-icon>
            <!-- <span class="ms-1">Descargar</span> -->
          </button>

          <button class="btn btn-warning btn-sm"
                  *ngIf="!vistaMensual"
                  [disabled]="!cod_bodega || !fechaSeleccionada"
                  (click)="onGestionarServiciosDiaClick()"
                  title="Cerrar o abrir masivamente los servicios del día de picking seleccionado">
            <mat-icon class="small-icon">event_repeat</mat-icon>
            <span class="ms-1">Gestionar servicios del día</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Vista normal (cards) -->
  <div id="dashboard" class="responsive-grid" *ngIf="!vistaMensual">
    <div class="card" *ngFor="let poly of poligonos" [hidden]="poly.cubicajeAct === 0 && poly.ordenesAct === 0">
      <div class="card-header-custom">
        <div class="estado-badge" [ngClass]="poly.estado === 'abierto' ? 'abierto' : 'cerrado'">
          {{poly.estado === 'abierto' ? 'Abierto' : 'Cerrado'}}
        </div>
        <div class="cierre-toggle">
          <mat-slide-toggle [checked]="poly.estado === 'abierto'" (change)="onToggleChange($event, poly)" class="toggle-small">
          </mat-slide-toggle>
        </div>
      </div>
      <h2 class="poly-title">{{poly.descripcion}}</h2>
      <div class="info-row">
        <div class="info-item">
          <div class="info-label">Cubicaje:</div>
          <div class="info-value">{{poly.cubicajeAct | number:'1.2-2'}} / {{poly.cubicajeMax}}</div>
        </div>
        <div class="info-item">
          <div class="info-label">Órdenes:</div>
          <div class="info-value">{{poly.ordenesAct}} / {{poly.ordenesMax}}</div>
        </div>
      </div>
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill" [ngClass]="getAlertaClass(getPorcentajeNum(poly.cubicajeAct, poly.cubicajeMax))"
            [style.width.%]="getPorcentajeNum(poly.cubicajeAct, poly.cubicajeMax)">
            <span class="progress-label">
              <mat-icon class="progress-icon">inventory_2</mat-icon>
              Cubicaje
            </span>
            <span class="progress-percentage">{{getPorcentaje(poly.cubicajeAct, poly.cubicajeMax)}}%</span>
          </div>
          <span class="progress-label-bg">
            <mat-icon class="progress-icon">inventory_2</mat-icon>
            Cubicaje
          </span>
        </div>
      </div>
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill" [ngClass]="getAlertaClass(getPorcentajeNum(poly.ordenesAct, poly.ordenesMax))"
            [style.width.%]="getPorcentajeNum(poly.ordenesAct, poly.ordenesMax)">
            <span class="progress-label">
              <mat-icon class="progress-icon">receipt_long</mat-icon>
              Órdenes
            </span>
            <span class="progress-percentage">{{getPorcentaje(poly.ordenesAct, poly.ordenesMax)}}%</span>
          </div>
          <span class="progress-label-bg">
            <mat-icon class="progress-icon">receipt_long</mat-icon>
            Órdenes
          </span>
        </div>
      </div>
      <div class="text-center mt-2 mb-1 d-flex gap-2 justify-content-center">
        <button class="btn btn-info btn-sm py-1 px-3" (click)="obtenerDetalle(poly.id)" title="Descargar Excel">
          <mat-icon class="small-icon align-middle">description</mat-icon>
        </button>
        <button class="btn btn-info btn-sm py-1 px-3" (click)="abrirModalDetalle(poly)" title="Ver detalle">
          <mat-icon class="small-icon align-middle">visibility</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Vista mensual (tabla) -->
  <div class="monthly-table-container" *ngIf="vistaMensual">
    <div class="table-responsive">
      <table class="table table-bordered monthly-table">
        <thead>
          <tr>
            <th class="fecha-header">FECHA</th>
            <th *ngFor="let nombre of nombresPoligonos">{{nombre}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fecha of fechasDelMes">
            <td class="fecha-cell">{{fecha | date:'dd/MM'}}</td>
            <td *ngFor="let nombre of nombresPoligonos" class="polygon-cell">
              <div class="minimal-card" *ngIf="getPoligonoByFechaYNombre(fecha, nombre) as poly">
                <div class="status-row">
                  <span class="status" [ngClass]="poly.estado === 'abierto' ? 'open' : 'closed'">
                    {{poly.estado === 'abierto' ? 'A' : 'C'}}
                  </span>
                </div>
                <div class="toggle-corner">
                  <mat-slide-toggle [checked]="poly.estado === 'abierto'" (change)="onToggleChange($event, poly)" class="toggle-mini">
                  </mat-slide-toggle>
                </div>
                <div class="detail-corner">
                    <mat-icon (click)="abrirModalDetalle(poly)" title="Ver detalle">visibility</mat-icon>
                </div>
                <div class="values">
                  <div class="value-line large-text">
                    <mat-icon class="value-icon">inventory_2</mat-icon>
                    {{poly.cubicajeAct | number:'1.2-2'}}/{{poly.cubicajeMax}}
                  </div>
                  <div class="value-line large-text">
                    <mat-icon class="value-icon">receipt_long</mat-icon>
                    {{poly.ordenesAct}}/{{poly.ordenesMax}}
                  </div>
                </div>
                <div class="progress-section">
                  <div class="progress-bar-mini">
                    <div class="progress-fill-mini" [ngClass]="getAlertaClass(getPorcentajeNum(poly.cubicajeAct, poly.cubicajeMax))"
                      [style.width.%]="getPorcentajeNum(poly.cubicajeAct, poly.cubicajeMax)">
                      <span class="progress-label-mini">
                        <mat-icon class="progress-icon-mini">inventory_2</mat-icon>
                        Cubicaje
                      </span>
                      <span class="progress-percentage-mini">{{getPorcentaje(poly.cubicajeAct, poly.cubicajeMax)}}%</span>
                    </div>
                    <span class="progress-label-bg-mini">
                      <mat-icon class="progress-icon-mini">inventory_2</mat-icon>
                      Cubicaje
                    </span>
                  </div>
                </div>
                <div class="progress-section">
                  <div class="progress-bar-mini">
                    <div class="progress-fill-mini" [ngClass]="getAlertaClass(getPorcentajeNum(poly.ordenesAct, poly.ordenesMax))"
                      [style.width.%]="getPorcentajeNum(poly.ordenesAct, poly.ordenesMax)">
                      <span class="progress-label-mini">
                        <mat-icon class="progress-icon-mini">receipt_long</mat-icon>
                        Órdenes
                      </span>
                      <span class="progress-percentage-mini">{{getPorcentaje(poly.ordenesAct, poly.ordenesMax)}}%</span>
                    </div>
                    <span class="progress-label-bg-mini">
                      <mat-icon class="progress-icon-mini">receipt_long</mat-icon>
                      Órdenes
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>